module.exports = __webpack_public_path__ + "static/img/arrow-a-lg.edb1d13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myBrand/component/img/arrow-a-lg.svg
// module id = EaBQ
// module chunks = 66